import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import AssetAssociationsOrganizations from './assetAssociationsOrganizations';
import Icon from '../common/containers/icon';
import MultiPicker from '../common/controls/multiPicker';
import entityComposition from '../common/classes/entityComposition';
class AssetAssociations extends React.Component {
  constructor(props) {
    super(props);
    this.handleAddOrganization = this.handleAddOrganization.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      assetAssociationsDocument = _this$props.assetAssociationsDocument,
      assetAssociationsDocumentActions = _this$props.assetAssociationsDocumentActions,
      assetAssociationsEmployee = _this$props.assetAssociationsEmployee,
      assetAssociationsEmployeeActions = _this$props.assetAssociationsEmployeeActions,
      assetAssociationsJob = _this$props.assetAssociationsJob,
      assetAssociationsJobActions = _this$props.assetAssociationsJobActions,
      assetAssociationsOrganization = _this$props.assetAssociationsOrganization,
      assetAssociationsOrganizationActions = _this$props.assetAssociationsOrganizationActions,
      assetAssociationsFacility = _this$props.assetAssociationsFacility,
      assetAssociationsFacilityActions = _this$props.assetAssociationsFacilityActions,
      assetAssociationsGroup = _this$props.assetAssociationsGroup,
      assetAssociationsGroupActions = _this$props.assetAssociationsGroupActions,
      assetAssociationsArea = _this$props.assetAssociationsArea,
      assetAssociationsAreaActions = _this$props.assetAssociationsAreaActions;
    assetAssociationsDocumentActions.serverIndex(assetAssociationsDocument.indexQuery);
    assetAssociationsEmployeeActions.serverIndex(assetAssociationsEmployee.indexQuery);
    assetAssociationsJobActions.serverIndex(assetAssociationsJob.indexQuery);
    assetAssociationsOrganizationActions.serverIndex(assetAssociationsOrganization.indexQuery);
    assetAssociationsFacilityActions.serverIndex(assetAssociationsFacility.indexQuery);
    assetAssociationsGroupActions.serverIndex(assetAssociationsGroup.indexQuery);
    assetAssociationsAreaActions.serverIndex(assetAssociationsArea.indexQuery);
  }
  handleAddOrganization() {
    const _this$props2 = this.props,
      _this$props2$asset = _this$props2.asset,
      assetID = _this$props2$asset.id,
      organizations = _this$props2$asset.organizations,
      assetActions = _this$props2.assetActions;
    const orgs = JSON.parse(JSON.stringify(organizations || []));
    orgs.push({
      id: null,
      facilities: []
    });
    assetActions.change(assetID, 'organizations', orgs);
  }
  render() {
    const _this$props3 = this.props,
      assetActions = _this$props3.assetActions,
      _this$props3$asset = _this$props3.asset,
      assetID = _this$props3$asset.id,
      jobs = _this$props3$asset.jobs,
      organizations = _this$props3$asset.organizations,
      employees = _this$props3$asset.employees,
      documents = _this$props3$asset.documents,
      assetAssociationsDocument = _this$props3.assetAssociationsDocument,
      assetAssociationsEmployee = _this$props3.assetAssociationsEmployee,
      assetAssociationsJob = _this$props3.assetAssociationsJob,
      orgList = _this$props3.assetAssociationsOrganization.list,
      facList = _this$props3.assetAssociationsFacility.list,
      grpList = _this$props3.assetAssociationsGroup.list,
      areaList = _this$props3.assetAssociationsArea.list;
    const handleChangeEmployees = value => assetActions.change(assetID, 'employees', value);
    const handleChangeJobs = value => assetActions.change(assetID, 'jobs', value);
    const handleChangeDocuments = value => assetActions.change(assetID, 'documents', value);
    const handleChangeOrganizations = (path, value) => assetActions.change(assetID, path, value);
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, "Associations"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(MultiPicker, {
      label: "Associated Employees",
      onChange: handleChangeEmployees,
      options: assetAssociationsEmployee.list,
      placeholder: "Select...",
      values: employees,
      returnValueKey: "id",
      searchable: false
    }), /*#__PURE__*/React.createElement(MultiPicker, {
      label: "Associated Jobs",
      onChange: handleChangeJobs,
      options: assetAssociationsJob.list,
      placeholder: "Select...",
      values: jobs,
      returnValueKey: "id",
      searchable: false,
      labelKey: "jobNumber"
    }), /*#__PURE__*/React.createElement(MultiPicker, {
      label: "Associated Library Documents",
      onChange: handleChangeDocuments,
      options: assetAssociationsDocument.list,
      placeholder: "Select...",
      values: documents,
      returnValueKey: "id",
      searchable: false
    }), /*#__PURE__*/React.createElement(AssetAssociationsOrganizations, {
      organizations: organizations,
      onChange: handleChangeOrganizations,
      orgList: orgList,
      facList: facList,
      grpList: grpList,
      areaList: areaList
    }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleAddOrganization,
      className: "float-md-right form-control t-aa-add-organization tqc-control"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Organization"))));
  }
}
AssetAssociations.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    organizations: PropTypes.arrayOf(PropTypes.shape({})),
    jobs: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
    documents: PropTypes.arrayOf(PropTypes.shape({})),
    employees: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetActions: PropTypes.shape({
    change: PropTypes.func
  }).isRequired,
  assetAssociationsDocument: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetAssociationsDocumentActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetAssociationsEmployee: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetAssociationsEmployeeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetAssociationsJob: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetAssociationsJobActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetAssociationsOrganization: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetAssociationsOrganizationActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetAssociationsFacility: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetAssociationsFacilityActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetAssociationsGroup: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetAssociationsGroupActions: PropTypes.shape({
    serverFilter: PropTypes.func,
    serverIndex: PropTypes.func
  }).isRequired,
  assetAssociationsArea: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetAssociationsAreaActions: PropTypes.shape({
    serverFilter: PropTypes.func,
    serverIndex: PropTypes.func
  }).isRequired
};
export { AssetAssociations as TestAssetAssociations };
export default entityComposition(AssetAssociations, ['assetAssociationsDocument', 'assetAssociationsEmployee', 'assetAssociationsJob', 'assetAssociationsOrganization', 'assetAssociationsFacility', 'assetAssociationsGroup', 'assetAssociationsArea']);